/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE = '/payment';
const RESOURCE_PAGE_PAYMENT_METHOD_CARTSERVICE = '/visacheckout';
const RESOURCE_PAGE_CARTSERVICE = '/processdata';

/**
 * processVisaCheckoutData
 * url - /checkout/{apiversion}/payment/{cartId}/visacheckout/processdata?brand={brandId}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.payload
 * @param {String} args.encryptKey
 * @param {String} args.sourceApp
 */
const processVisaCheckoutData = ({
    env, jwtToken, cartId, payloadData, encryptKey, sourceApp,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const payload = {
        payloadData,
        encryptKey,
        sourceApp,
    };

    const resourcePage =  `${RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_PAYMENT_METHOD_CARTSERVICE}${RESOURCE_PAGE_CARTSERVICE}`;

    return restClient.postRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default processVisaCheckoutData;
